import React from 'react';
import { formatFieldName, formatValue } from '../../utils/formatters';

const DonationsSection = ({ donationAnswers }) => {
    if (donationAnswers.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Donations</h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px'
            }}>
                {donationAnswers.map(([field, value]) => {
                    const isNotesField = field === 'donation_notes';
                    return (
                        <div
                            key={field}
                            style={{
                                backgroundColor: '#2d2d2d',
                                border: '1px solid #404040',
                                borderRadius: '6px',
                                padding: '15px',
                                gridColumn: isNotesField ? '1 / -1' : undefined
                            }}
                        >
                            <div style={{
                                fontSize: '12px',
                                color: '#a0a0a0',
                                textTransform: 'uppercase',
                                marginBottom: '8px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                {formatFieldName(field)}
                            </div>
                            <div style={{
                                fontSize: isNotesField ? '14px' : '18px',
                                fontWeight: isNotesField ? '500' : 'bold',
                                color: '#e0e0e0',
                                lineHeight: isNotesField ? '1.6' : '1.2',
                                whiteSpace: isNotesField ? 'pre-wrap' : 'normal'
                            }}>
                                {formatValue(value)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DonationsSection;






